/**
 * State used in rendering InfoLabel
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
